import { render, staticRenderFns } from "./BillsItemForm.vue?vue&type=template&id=e4bfdbfa&scoped=true&"
import script from "./BillsItemForm.vue?vue&type=script&lang=js&"
export * from "./BillsItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bfdbfa",
  null
  
)

export default component.exports